<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-23 13:46:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-23 16:43:11
 * @name: 费用展示
 * @Description: 费用展示 
 * @FilePath: \project\src\components\afterSale\dialog-fee-show.vue
 * @Author: desktop
-->
<template>
  <div>
    <el-dialog
      width="60%"
      title="查看金额"
      :visible.sync="show"
    >
      <div class="container">
        <div class="part">
          <font class="title">部件</font>
          <div class="fees">
            <template v-for="item of fee">
              <template v-if="item.parent === 'parts_fee'">
                <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                  <font class="label">{{ item.label }}：</font>
                  <font class="text">{{ item.value }}元</font>
                </div>
                <div
                  class="remark"
                  :key="item.key"
                  v-else-if="item.type === 'remark'"
                >
                  <font class="label">备注：</font>
                  <font class="text">{{ item.value }}</font>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="part">
          <font class="title">工资</font>
          <div class="fees">
            <template v-for="item of fee">
              <template v-if="item.parent === 'salary'">
                <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                  <font class="label">{{ item.label }}：</font>
                  <font class="text">{{ item.value }}元</font>
                </div>
                <div
                  class="remark"
                  :key="item.key"
                  v-else-if="item.type === 'remark'"
                >
                  <font class="label">备注：</font>
                  <font class="text">{{ item.value }}</font>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="part">
          <font class="title">运费</font>
          <div class="fees">
            <template v-for="item of fee">
              <template v-if="item.parent === 'trans_port'">
                <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                  <font class="label">{{ item.label }}：</font>
                  <font class="text">{{ item.value }}元</font>
                </div>
                <div
                  class="remark"
                  :key="item.key"
                  v-else-if="item.type === 'remark'"
                >
                  <font class="label">备注：</font>
                  <font class="text">{{ item.value }}</font>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="part">
          <font class="title">其它</font>
          <div class="fees">
            <template v-for="item of fee">
              <template v-if="item.parent === 'others'">
                <div class="fee" :key="item.key" v-if="item.type === 'fee'">
                  <font class="label">{{ item.label }}：</font>
                  <font class="text">{{ item.value }}元</font>
                </div>
                <div
                  class="remark"
                  :key="item.key"
                  v-else-if="item.type === 'remark'"
                >
                  <font class="label">备注：</font>
                  <font class="text">{{ item.value }}</font>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="btn-group">
          <el-button
            size="mini"
            @click="update"
            v-if="
              $route.query.run_act === 'cwdingjia' &&
              Number($route.query.run_status) === 0
            "
            >修改</el-button
          >
          <el-button size="mini" @click="quickEdit" v-if="edit_fee_allow"
            >修改</el-button
          >
          <el-button size="mini" type="primary" @click="confirm"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <dialog-fee-sign
      ref="dialogFeeSign"
      :origin="origin"
      :needSelect="needSelect"
      @feeSignConfirm="feeSignConfirm"
    ></dialog-fee-sign>
  </div>
</template>
<script>
import dialogFeeSign from "@/components/afterSale/dialog-fee-sign";
import { debounceation } from "@/utils/decorator";
export default {
  components: {
    dialogFeeSign,
  },
  props: {
    origin: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      show: false,
      fee: [],
      pay_user: 1,
      need_pay: 1,
      edit_fee_allow: false,
    };
  },
  computed: {
    needSelect() {
      let arr = [];
      if (
        this.$route.query.run_act === "cwdingjia" &&
        Number(this.$route.query.run_status) === 0
      ) {
        arr = ["need_pay", "pay_user"];
      } else if (this.edit_fee_allow) {
        arr = ["pay_user"];
      }
      return arr;
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开显示费用弹窗
     * @param {Object} fee 费用
     */
    open(fee) {
      this.fee = fee;
      this.pay_user = this.origin.pay_user;
      this.need_pay = this.origin.need_pay;
      this.edit_fee_allow = this.origin.edit_fee_allow;
      this.show = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 确认费用
     */
    @debounceation(300)
    confirm() {
      if (
        this.$route.query.run_act === "cwdingjia" &&
        Number(this.$route.query.run_status) === 0
      ) {
        this.$emit("confirmFee", {
          need_pay: this.need_pay,
          pay_user: this.pay_user,
          fee: this.fee,
        });
      } else if (this.edit_fee_allow) {
        this.$emit("quickConfirmFee", {
          need_pay: this.need_pay,
          pay_user: this.pay_user,
          fee: this.fee,
        });
      }
      this.show = false;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击修改,打开修改费用弹窗(财务)
     */
    @debounceation(300)
    update() {
      this.$refs.dialogFeeSign.open(this.fee);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击修改,打开修改费用弹窗(售后)
     */
    @debounceation(300)
    quickEdit() {
      this.$refs.dialogFeeSign.open(this.fee);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 修改费用确认
     * @param {Object} obj 费用信息
     */
    @debounceation(300)
    feeSignConfirm(obj) {
      this.fee = obj.fee;
      this.pay_user = obj.pay_user;
      this.need_pay = obj.need_pay;
      this.confirm();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  @extend .et-flex-column-normal;
  .part {
    width: 100%;
    padding: 10px 0;
    @extend .et-flex-column-normal;
    .title {
      font-size: $Vars-font-miniTitle-size;
      font-weight: bold;
      color: $Vars-font-important-color;
      padding-bottom: 10px;
    }
    .fees {
      padding: 10px 0;
      width: 100%;
      @extend .et-flex-normal;
      .fee {
        width: 25%;
        box-sizing: border-box;
        padding: 5px 10px;
        @extend .et-flex-start;
        font-size: $Vars-font-content-size;
        .label {
          min-width: calc(#{$Vars-font-content-size} * 4);
          margin-right: 10px;
          text-align: right;
        }
        .text {
          flex: 1;
        }
      }
      .remark {
        width: 100%;
        box-sizing: border-box;
        padding: 5px 10px;
        @extend .et-flex-normal;
        .label {
          min-width: calc(#{$Vars-font-content-size} * 4);
          margin-right: 10px;
          text-align: right;
        }
        .text {
          flex: 1;
        }
      }
    }
  }
  .btn-group {
    margin: 20px 0 0;
    width: 100%;
    @extend .et-flex-center;
  }
}
</style>